<template>
  <div id="service-documents">
    <v-row v-if="isLoading" no-gutters>
      <v-col cols="12">
        <div style="width: 100%; height: 100%; position: absolute; z-index: 1"></div>
      </v-col>
    </v-row>
    <div v-else ref="capture">
      <v-row no-gutters style="margin-bottom: 30px">
        <v-col cols="12">
          <div></div>
          <h3 class="document-title">서비스 이용 계약서</h3>
          <div class="document-information">
            “회원”과 “회사”는 다음과 같은 조건으로 서비스 이용계약을 체결한다<br />
             <br />
            제1조 계약의 목적<br />
            본 계약은 “회원”이 “회사”의 서비스를 이용함에 있어 필요한 제반 사항을 규정하는데 목적이
            있다.<br />
             <br />
            제2조 서비스 및 이용요금등<br />
            “회사”가 “회원”에게 제공하는 서비스는 아래와 같으며, 그 세부 내용은 “회사”의 이용약관 의
            내용으로 한다.<br />
            <DocumentDebtorFeeSetting />
             <br />
            제3조 계약의 문서 및 적용<br />
            ⓵ “회원”과 “회사”는 “회원”이 동의한 아래 계약(이하“약관”)이 본 계약의 일부가 됨을
            확인한다.<br />
              - 서비스 이용약관<br />
            ⓶ 본 계약의 전항의 약관에 우선하는 효력을 가지며, 본 계약에 기재되지 아니한 사항은
            전항의 약관에 의한다.<br />
            ⓷ 본 계약은 계약체결일로부터 서비스이용 해지 의사 표현일까지 효력을 가진다.<br />
            <br />
            제4조 계약의 해지<br />
            ⓵ “회원”은 언제든지 “회사”가 정한 해지절차에 따라<br />
            서비스 이용을 해지할 수 있다. 다만, 제휴서비스등의 잔액이 남아있을 경우, 완납후 해지가
            가능하다.<br />
            ⓶ “회사”는 “회원”이 본 계약 또는 약관의 내용을 위반하는 경우 본 계약을 해지할수 있다.<br />
             <br />
            제5조 서비스 이용자의 의무<br />
            “회원”은 건전하고 합법적인 목적으로 서비스를 이용하며, 본 계약 및 약관의 내용을
            준수한다.<br />
             <br />
            제6조 기타<br />
            계약일방의 귀책사유로 상대방에게 손해가 발생한 경우 그 손해에 대한 배상은 월 서비스
            이용요금을 한도로 하며, 분쟁발생시 당사자간 협의를 통해 이를 해결한다. 다만, 이로써
            해결되지 아니하는 경우 서울중앙지방법원을 관할법원으로 하여 해결한다<br />
          </div>
        </v-col>

        <v-col cols="12" class="py-5">
          <v-expansion-panels v-model="panel" multiple flat>
            <v-expansion-panel
              v-for="document in documents"
              :key="document.title"
              :ref="document.name"
              :class="{ camera: isCameraMode }"
            >
              <v-expansion-panel-header class="panel-header">
                <template v-slot:default>
                  <div class="d-flex align-center">
                    <div class="panel-header__checkbox">
                      <div :class="{ 'is-agree': document.isAgreed }">
                        <img class="cen" src="@/assets/images/icons/check.svg" />
                      </div>
                    </div>
                    <p class="panel-header__title">
                      {{ document.title }}
                    </p>
                  </div>
                </template>
                <template v-slot:actions>
                  <img class="v-icon" src="@/assets/images/icons/arrow-down.svg" />
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="py-3 px-0">
                <component
                  :is="document.component"
                  v-bind="{ cameraMode: isCameraMode }"
                  @emitAgreed="(v) => agreeDoc(document, v)"
                  @emitUserSign="(v) => emitUserSign(v)"
                >
                </component>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </div>
    <v-row no-gutters>
      <v-col cols="12" class="complete">
        <!-- <button @click="nextStep2()">
          <template v-if="nextLoading">
            <v-progress-circular size="24" indeterminate color="primary"></v-progress-circular>
          </template>
          <template v-else>다음</template>
        </button> -->
        <button
          :v-ripple="!btnDisabled"
          :disabled="btnDisabled"
          :class="{ active: !btnDisabled }"
          @click="nextStep()"
        >
          <template v-if="nextLoading">
            <v-progress-circular size="24" indeterminate color="primary"></v-progress-circular>
          </template>
          <template v-else>다음</template>
        </button>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import { sleep } from '@/util'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'

export default {
  components: {
    DocumentOrganization: () => import('@/components/documents/DocumentOrganization.vue'),
    DocumentCustomer: () => import('@/components/documents/DocumentCustomer.vue'),
    DocumentLimitTransactionSign: () =>
      import('@/components/documents/DocumentLimitTransactionSign.vue'),
    DocumentDebtorFeeSetting: () => import('@/components/documents/DocumentDebtorFeeSetting.vue'),
  },
  data() {
    return {
      origin: {
        contract: null,
        term: null,
      },
      contractImage: {
        signature: null,
        image: null,
      },
      showTemp: false,
      isLoading: false,
      isCameraMode: false,
      nextLoading: false,
      panel: [0],
      documents: [
        {
          name: 'DocumentOrganization',
          title: '회사 정보',
          isAgreed: false,
          component: 'DocumentOrganization',
        },
        {
          name: 'DocumentCustomer',
          title: '회원 정보',
          isAgreed: false,
          component: 'DocumentCustomer',
        },
        {
          name: 'DocumentLimitTransactionSign',
          title: '서명',
          isAgreed: false,
          component: 'DocumentLimitTransactionSign',
        },
      ],
    }
  },
  computed: {
    isAgreedAll() {
      return this.documents.every((d) => {
        return d.isAgreed === true
      })
    },
    btnDisabled() {
      return this.nextLoading === true || this.isAgreedAll === false
    },
    registerContractTerm() {
      return {
        contract: this.origin.contract?.uuid,
        term: this.origin.term?.uuid,
        isAgreed: true,
        signature: this.contractImage.signature, // 사인
        image: this.contractImage.image, // 계약서 전체
      }
    },
    ...mapGetters('myfinbiz', ['platformName']),
  },
  async created() {
    const contract = await this.getContractsAgreementsMyfinbizService()
    const hasContract = await this.checkExistContract(contract)
    if (hasContract) {
      return this.$router.push('/earlypay')
    }
    this.origin.contract = await this.getContractCurrent()
    this.origin.term = await this.getContractTermsCode({ code: 'MYFINBIZ_SERVICE' })
    await this.getLoansExecuteFunding()
  },
  methods: {
    ...mapActions('agreement', [
      'getContractAgreements',
      'getContractCurrent',
      'getContractTermsCode',
      'addContractAgreements',
    ]),
    ...mapActions('loan', ['getLoansExecuteFunding']),
    ...mapActions('contract', ['checkExistContract']),
    ...mapActions('myfinbiz', ['getContractsAgreementsMyfinbizService']),
    openAllPanels() {
      this.panel = this.documents.map((k, i) => i)
    },
    agreeDoc(document, v) {
      document.isAgreed = v
      if (v === true) {
        const current = this.documents.findIndex((doc) => doc.name === document.name)
        const pan = this.panel.indexOf(current)
        if (pan > -1 && current < this.documents.length - 1) {
          this.panel.splice(pan, 1)
          this.panel.push(current + 1)

          this.$refs[document.name][0].$el.scrollIntoView({ behavior: 'smooth' })
        }
      }
    },
    capture() {
      const result = new Promise(async (resolve, reject) => {
        const element = this.$refs.capture
        const canvas = await html2canvas(element, {
          x: 0,
          y: 0,
          scale: 1,
          useCORS: true,
        })
        canvas.toBlob(resolve)
      })
      return result
    },
    async nextStep() {
      if (this.btnDisabled) {
        return
      }

      try {
        this.nextLoading = true
        this.isCameraMode = true

        this.openAllPanels()
        await sleep(1500)

        if (this.panel.length === this.documents.length) {
          this.contractImage.image = await this.capture()
        }
        console.log(this.registerContractTerm)
        await this.addContractAgreements(this.registerContractTerm)
        this.$emit('emitResult', true)
      } finally {
        this.isCameraMode = false
        this.nextLoading = false
      }
    },
    emitUserSign(v) {
      this.contractImage.signature = v
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common/_variables.scss';

#service-documents {
  display: block;
  width: 100%;

  background-color: $white;
  box-sizing: border-box;

  .document-title {
    font-weight: 900;
    text-align: center;

    margin-top: 20px;
    margin-bottom: 20px;
  }

  .document-information {
    background-color: #f4faff;
    color: #333333;
    font-size: 16px;
    line-height: 1.5;

    padding: 20px 36px;
  }

  .v-expansion-panel {
    background-color: #f4faff;
    border-radius: $border-radius-default !important;

    &:not(:first-child) {
      margin-top: 16px;
    }

    &:not(.camera):before {
      box-shadow: 0 6px 16px 0 rgba(32, 35, 36, 0.08) !important;
    }

    &:not(.camera) {
      .v-expansion-panel-header--active {
        box-shadow: 0 6px 16px 0 rgba(32, 35, 36, 0.08) !important;
      }
    }

    &.v-expansion-panel--active::before {
      box-shadow: unset !important;
    }
  }

  .v-expansion-panel-content {
    background-color: white;
  }

  :deep(.v-expansion-panel-content__wrap) {
    padding: 0;
  }

  .panel-header {
    background-color: #f4faff;
    height: 60px;

    &__checkbox {
      width: 52px;

      > div {
        display: flex;
        align-items: center;
        justify-content: center;

        width: 24px;
        height: 24px;

        background-color: #d7e1ea;
        border-radius: 100%;

        &.is-agree {
          background-color: $main-color-default;
        }
      }

      img {
        object-fit: contain;
      }
    }

    &__title {
      color: #8a94a2;
      font-size: 15px !important;
      font-weight: 900 !important;
      white-space: nowrap;
      word-wrap: break-word;

      margin: 0;
      padding-left: 8px;
    }
  }

  .complete {
    position: relative;

    button {
      width: 100%;
      max-width: $standard-max-width;
      height: 68px;
      bottom: 0;
      color: #727d8c;
      font-weight: 900;
      font-size: 22px;
      text-align: center;
      background-color: #e3ecf6;
      z-index: 100;

      &.active {
        color: $white;
        background-color: $main-color-default;
      }
    }
  }

  :deep {
    .agree {
      p {
        font-weight: 600;
        font-size: 16px;
        line-height: 48px;
      }

      button {
        width: 80px;
        height: 48px;
        border-radius: 4px;
        border: solid 1px #d7e1ea;
        background-color: $white;
        color: #727d8c;
        font-size: 15px;
        line-height: 1.6;
      }
    }
  }

  :deep(button.active) {
    background-color: $main-color-default;
    border-color: $main-color-default;
    color: $white;
    font-weight: bold;
  }
}
</style>
